var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardOnboardingIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "u1_Path_83778",
    x: 0,
    y: 0,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "u1_blur1"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#1450ff",
    floodOpacity: 0.208
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "u1_blur1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "u1_Path_83777",
    x: 15,
    y: 15,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "u1_blur2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#1450ff",
    floodOpacity: 0.208
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "u1_blur2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u1_linear-gradient",
    x1: 0.817,
    y1: -0.024,
    x2: 0.244,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a0deff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3a76fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003cbe"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "u1_Path_83776",
    x: 22.279,
    y: 21.223,
    width: 43.442,
    height: 49.553,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "u1_blur3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#165cf3",
    floodOpacity: 0.486
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "u1_blur3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "u1_Group_161838",
    transform: "translate(-1233 -751)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "u1_Quick_Tour_-_Step_Guide_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "u1_Group_161829",
    transform: "translate(0 -12)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1233, 763)",
    filter: "url(#u1_Path_83778)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24 21)",
    fill: "#f2ffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20 39.5 C 17.3673 39.5 14.8136 38.9845 12.4099 37.9678 C 10.0879 36.9857 8.00243 35.5796 6.21142 33.7886 C 4.42041 31.9976 3.01432 29.9121 2.0322 27.5901 C 1.01551 25.1864 0.5 22.6327 0.5 20 C 0.5 17.3673 1.01551 14.8136 2.0322 12.4099 C 3.01432 10.0879 4.42041 8.00243 6.21142 6.21142 C 8.00243 4.42041 10.0879 3.01432 12.4099 2.0322 C 14.8136 1.01551 17.3673 0.5 20 0.5 C 22.6327 0.5 25.1864 1.01551 27.5901 2.0322 C 29.9121 3.01432 31.9976 4.42041 33.7886 6.21142 C 35.5796 8.00243 36.9857 10.0879 37.9678 12.4099 C 38.9845 14.8136 39.5 17.3673 39.5 20 C 39.5 22.6327 38.9845 25.1864 37.9678 27.5901 C 36.9857 29.9121 35.5796 31.9976 33.7886 33.7886 C 31.9976 35.5796 29.9121 36.9857 27.5901 37.9678 C 25.1864 38.9845 22.6327 39.5 20 39.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20 1 C 17.4346 1 14.9464 1.50222 12.6047 2.4927 C 10.3423 3.44961 8.31022 4.81972 6.56497 6.56497 C 4.81972 8.31022 3.44961 10.3423 2.4927 12.6047 C 1.50222 14.9464 1 17.4346 1 20 C 1 22.5654 1.50222 25.0536 2.4927 27.3954 C 3.44961 29.6577 4.81972 31.6898 6.56497 33.435 C 8.31022 35.1803 10.3423 36.5504 12.6047 37.5073 C 14.9464 38.4978 17.4346 39 20 39 C 22.5654 39 25.0536 38.4978 27.3954 37.5073 C 29.6577 36.5504 31.6898 35.1803 33.435 33.435 C 35.1803 31.6898 36.5504 29.6577 37.5073 27.3954 C 38.4978 25.0536 39 22.5654 39 20 C 39 17.4346 38.4978 14.9464 37.5073 12.6047 C 36.5504 10.3423 35.1803 8.31022 33.435 6.56497 C 31.6898 4.81972 29.6577 3.44961 27.3954 2.4927 C 25.0536 1.50222 22.5654 1 20 1 M 20 0 C 31.0457 0 40 8.9543 40 20 C 40 31.0457 31.0457 40 20 40 C 8.9543 40 0 31.0457 0 20 C 0 8.9543 8.9543 0 20 0 Z",
    stroke: "none",
    fill: "#f2f6ff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1233, 763)",
    filter: "url(#u1_Path_83777)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24 21)",
    fill: "#f2f6ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20 39.5 C 17.3673 39.5 14.8136 38.9845 12.4099 37.9678 C 10.0879 36.9857 8.00243 35.5796 6.21142 33.7886 C 4.42041 31.9976 3.01432 29.9121 2.0322 27.5901 C 1.01551 25.1864 0.5 22.6327 0.5 20 C 0.5 17.3673 1.01551 14.8136 2.0322 12.4099 C 3.01432 10.0879 4.42041 8.00243 6.21142 6.21142 C 8.00243 4.42041 10.0879 3.01432 12.4099 2.0322 C 14.8136 1.01551 17.3673 0.5 20 0.5 C 22.6327 0.5 25.1864 1.01551 27.5901 2.0322 C 29.9121 3.01432 31.9976 4.42041 33.7886 6.21142 C 35.5796 8.00243 36.9857 10.0879 37.9678 12.4099 C 38.9845 14.8136 39.5 17.3673 39.5 20 C 39.5 22.6327 38.9845 25.1864 37.9678 27.5901 C 36.9857 29.9121 35.5796 31.9976 33.7886 33.7886 C 31.9976 35.5796 29.9121 36.9857 27.5901 37.9678 C 25.1864 38.9845 22.6327 39.5 20 39.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20 1 C 17.4346 1 14.9464 1.50222 12.6047 2.4927 C 10.3423 3.44961 8.31022 4.81972 6.56497 6.56497 C 4.81972 8.31022 3.44961 10.3423 2.4927 12.6047 C 1.50222 14.9464 1 17.4346 1 20 C 1 22.5654 1.50222 25.0536 2.4927 27.3954 C 3.44961 29.6577 4.81972 31.6898 6.56497 33.435 C 8.31022 35.1803 10.3423 36.5504 12.6047 37.5073 C 14.9464 38.4978 17.4346 39 20 39 C 22.5654 39 25.0536 38.4978 27.3954 37.5073 C 29.6577 36.5504 31.6898 35.1803 33.435 33.435 C 35.1803 31.6898 36.5504 29.6577 37.5073 27.3954 C 38.4978 25.0536 39 22.5654 39 20 C 39 17.4346 38.4978 14.9464 37.5073 12.6047 C 36.5504 10.3423 35.1803 8.31022 33.435 6.56497 C 31.6898 4.81972 29.6577 3.44961 27.3954 2.4927 C 25.0536 1.50222 22.5654 1 20 1 M 20 0 C 31.0457 0 40 8.9543 40 20 C 40 31.0457 31.0457 40 20 40 C 8.9543 40 0 31.0457 0 20 C 0 8.9543 8.9543 0 20 0 Z",
    stroke: "none",
    fill: "#f2f6ff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1233, 763)",
    filter: "url(#u1_Path_83776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.691.078a.611.611,0,0,1,.277.709l-2.2,7.151h4.061a.611.611,0,0,1,.445,1.03L33.5,19.355a.611.611,0,0,1-1.029-.6l2.2-7.152H30.609a.611.611,0,0,1-.445-1.03L39.94.187a.611.611,0,0,1,.752-.11Z",
    transform: "translate(7.28 31.23)",
    fill: "url(#u1_linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    transform: "translate(1275 782)",
    fill: "#165cf3",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardOnboardingIcon);
export default __webpack_public_path__ + "static/media/dashboard-onboarding-icon.ae440b8663ca36ed28046543b9910926.svg";
export { ForwardRef as ReactComponent };